module.exports = __webpack_public_path__ + "img/icon_bg@2x.58aadcc9.png";